import React from 'react';

import Section from '../Section';

const Reflections = () => (
  <Section title="Reflections" shade={4}>
    <h3>What I Learned</h3>
    <ul>
      <li>
        Revisiting user pain points often is important to ensure all design
        details are solving their problems
      </li>
      <li>
        Focusing prototype fidelity on just the amount needed for user testing
        can help allow more design iteration
      </li>
    </ul>
    <blockquote>
      "Matt successfully delivered in a poised and professional manner. He
      collaborated with us to draft the project plan and set incremental
      milestones, and led all aspects of the design effort across initial
      discovery, user interviews, visual and interaction design, and production
      of final high fidelity mockups and style guide. Matt also brings excellent
      soft skills to the table; he's an effective communicator with both
      internal and external stakeholders. For the time that he was with us, he
      really became part of our team and was a pleasure to work with. Matt can
      be an asset to any team and organization." <br />
      <br />- Arash Nasibi, CEO & Co-Founder of Hazel Analytics
    </blockquote>
  </Section>
);

export default Reflections;



// WEBPACK FOOTER //
// ./src/components/hazel/Reflections.js